(() => {
  if (customElements.get('bf-book-worlds')) return;
  class BfBookWorlds extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.category = 'all';
      this.limit = 4;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-bf-more]')) {
          const previous = this.limit;
          this.limit += 4;
          this.render(true);
          // Preserve the viewport while moving keyboard focus into newly revealed books.
          this.matches()[previous]?.querySelector('a')?.focus({preventScroll:true});
          return;
        }
        const link = event.target.closest('[data-bf-category]');
        if (!link || link.closest('bf-book-worlds') !== this || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.category = link.dataset.bfCategory;
        this.limit = 4;
        this.render(true);
      }, {signal:this.abort.signal});
      this.render();
      this.loadRemainingPages();
    }
    disconnectedCallback() { this.abort?.abort(); }
    matches() {
      return [...this.querySelectorAll('[data-bf-topic]')].filter(card => this.category === 'all' || card.dataset.bfTopic.split(/\s+/).includes(this.category));
    }
    render(announce = false) {
      const matches = this.matches();
      const visible = new Set(matches.slice(0,this.limit));
      this.querySelectorAll('[data-bf-topic]').forEach(card => { card.hidden = !visible.has(card); });
      this.querySelectorAll('[data-bf-category]').forEach(link => {
        if (link.dataset.bfCategory === this.category) link.setAttribute('aria-current','true');
        else link.removeAttribute('aria-current');
      });
      const count = `${visible.size} von ${matches.length} Büchern`;
      const controls = this.querySelector('[data-bf-more-controls]');
      if (controls) controls.hidden = false;
      const label = this.querySelector('[data-bf-book-count]');
      if (label) label.textContent = count;
      const button = this.querySelector('[data-bf-more]');
      if (button) button.hidden = visible.size >= matches.length;
      const status = this.querySelector('[data-bf-book-status]');
      if (announce && status) status.textContent = count;
    }
    async loadRemainingPages() {
      let next = this.querySelector('[data-bf-next-page]');
      while (next && !this.abort.signal.aborted) {
        try {
          const url = new URL(next.href, location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {signal:this.abort.signal});
          if (!response.ok) return; // Keep the native next-page link available on failure.
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = [...doc.querySelectorAll('bf-book-worlds')].find(el => el.dataset.sectionId === this.dataset.sectionId);
          if (!section) return;
          this.querySelector('[data-bf-category-grid]').append(...section.querySelectorAll('[data-bf-topic]'));
          const following = section.querySelector('[data-bf-next-page]');
          if (following) next.href = following.href;
          else { next.remove(); next = null; }
          this.render();
        } catch { return; }
      }
    }
  }
  customElements.define('bf-book-worlds', BfBookWorlds);
})();
